import { IconButton } from "@mui/material";
import { NotificationItem } from "./NotificationItem";
import ListInfinitiveScrolling from "components/common/ListInfinitiveScrolling";

import {
  ListNotificationWrapper,
  NotificationHeader,
  NotificationHeaderTitle,
} from "./style";
import { ReactComponent as IconClose } from "assets/svg/20-close.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getListNotificationDataSelector,
  getListNotificationStatusSelector,
} from "modules/Notification/redux/selector";
import { ReduxStateType } from "redux-store/types";
import { getListNotificationStart } from "modules/Notification/redux/getListNoti";

interface NotificationPanelProps {
  onClose: () => void;
}

const NotificationPanel = ({ onClose }: NotificationPanelProps) => {
  const dispatch = useDispatch();
  const listNotification = useSelector(getListNotificationDataSelector);
  const listNotificationStatus = useSelector(getListNotificationStatusSelector);

  const loadMoreData = () => {
    if (listNotificationStatus !== ReduxStateType.LOADING) {
      dispatch(getListNotificationStart({ sort: "" }));
    }
  };

  const handleOnClose = () => {
    onClose();
  };

  return (
    <>
      {/* Header */}
      <NotificationHeader>
        <NotificationHeaderTitle>Thông báo</NotificationHeaderTitle>
        <IconButton
          onClick={handleOnClose}
          sx={{
            svg: {
              path: {
                fill: "white",
              },
            },
          }}
        >
          <IconClose />
        </IconButton>
      </NotificationHeader>

      {/* Notification List */}

      <ListNotificationWrapper>
        <ListInfinitiveScrolling
          id="notification"
          data={listNotification}
          itemColumns={{
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
          }}
          spacing={1.5}
          fetchMoreData={loadMoreData}
          maxHeight={450}
        >
          {({ index }) => {
            return (
              <NotificationItem
                key={listNotification[index].id}
                notification={listNotification[index]}
                onClickItem={handleOnClose}
              />
            );
          }}
        </ListInfinitiveScrolling>
      </ListNotificationWrapper>
    </>
  );
};

export default NotificationPanel;
